// | Wrapper around I18n.js library.
// |
// | Currently only wraps `I18n.locale`, because Pendolino and PR have
// | differences around using `translate`.
import * as $runtime from "../runtime.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Effect$dConsole from "../Effect.Console/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import {_getGlobalLocale} from "./foreign.js";
const getGlobalLocale = () => {
  const str = _getGlobalLocale();
  const v = Restaumatic$dLocales.fromText(str);
  if (v.tag === "Nothing") {
    Effect$dConsole.log("WARNING: Invalid global locale: " + Data$dShow.showStringImpl(str) + ". Defaulting to " + Restaumatic$dLocales.showLocale.show(Restaumatic$dLocales.PL))();
    return Restaumatic$dLocales.PL;
  }
  if (v.tag === "Just") { return v._1; }
  $runtime.fail();
};
export {getGlobalLocale};
export * from "./foreign.js";
